import { useTheme } from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WidgetResizeHandle = ({
  isResizing,
  isEditable
}) => {
  const theme = useTheme();
  if (!isEditable) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    cursor: "se-resize",
    position: "absolute",
    as: "span",
    "data-test-id": "widget-resize-handle",
    insetBlockEnd: "0",
    insetInlineEnd: "0",
    paddingInlineEnd: "100",
    paddingBlockEnd: "100",
    inlineSize: "1.6rem",
    blockSize: "1.6rem",
    children: /*#__PURE__*/_jsxs("svg", {
      width: "22px",
      height: "22px",
      viewBox: "0 0 22 22",
      fill: isResizing ? theme.color['fill-secondary-default'] : theme.color['fill-secondary-hover'],
      children: [/*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "16",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "12",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "8",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "4",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "16",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "12",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "8",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "12",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "12",
        y: "16",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "12",
        y: "12",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8",
        y: "16",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "4",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "0",
        y: "20",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "4",
        y: "16",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8",
        y: "12",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "12",
        y: "8",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "16",
        y: "4",
        width: "2",
        height: "2"
      }), /*#__PURE__*/_jsx("rect", {
        x: "20",
        y: "0",
        width: "2",
        height: "2"
      })]
    })
  });
};
export default WidgetResizeHandle;